<template>
  <section id="course-page" class="course-page-section">
    <div class="container">
      <div class="row">
        <div class="col-md-9">
          <div class="blog-details-content">
            <div class="post-content-details">
              <!-- <div class="blog-detail-thumbnile mb35">
                <img :src="info.Attachments[0].Url" :alt="info.Attachments[0].Name">
              </div> -->
              <h2>{{info.Title}}</h2>

              <div class="date-meta text-uppercase">
                <span class="date-meta-text"><i class="fas fa-calendar-alt"></i> {{info.PublishTime}}</span>
                <!-- <span><i class="fas fa-user"></i> PRO.THEO HENRY</span> -->
              </div>
              <!-- <h3>Lorem ipsum dolor sit amet, consectetuer adipiscing elit </h3> -->
              <div class="ql-editor">
                <div v-html="info.Content"></div>
              </div>

              <div class="fujian" v-if="info.Attachments!==null">
                <span>附件：</span>
                <div>
                  <a v-for="item in info.Attachments" :key="item.Name" :href="item.Url" :download="item.Name">
                    <svg viewBox="0 0 16 16" width="14">
                      <g transform="translate(-128 -864)">
                        <path style="fill: #16cfd0;" d="M6.75,0h2.5A.748.748,0,0,1,10,.75V6h2.741a.624.624,0,0,1,.441,1.066L8.428,11.822a.605.605,0,0,1-.853,0L2.816,7.066A.624.624,0,0,1,3.256,6H6V.75A.748.748,0,0,1,6.75,0ZM16,11.75v3.5a.748.748,0,0,1-.75.75H.75A.748.748,0,0,1,0,15.25v-3.5A.748.748,0,0,1,.75,11H5.334l1.531,1.531a1.6,1.6,0,0,0,2.269,0L10.666,11H15.25A.748.748,0,0,1,16,11.75ZM12.125,14.5a.625.625,0,1,0-.625.625A.627.627,0,0,0,12.125,14.5Zm2,0a.625.625,0,1,0-.625.625A.627.627,0,0,0,14.125,14.5Z" transform="translate(128 864)" />
                      </g>
                    </svg>
                    {{item.Name}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <component :is="newsView" ref="newsView"></component>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import 'quill/dist/quill.core.css';
import { Vue, mapGetters } from '../../base/base.js';

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      info: 'getNewsDetails'
    })
  },
  created: function () {
    this.newsView = Vue.component('newsView', function (resolve) {
      require(['./list'], resolve)
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch('getNewsDetails', { Id: to.query.Id });
  },
  mounted() {
    this.$store.dispatch('getNewsDetails', { Id: this.$route.query.Id });
  }
}
</script>
<style lang="scss" scoped>
.post-content-details {
  h2 {
    font-weight: 600;
  }

  .ql-editor {
    font-size: 16px;
    line-height: 1.8;
    padding: 0;
    color: #333;
    box-sizing: border-box;

    /deep/ h1,
    /deep/ h2,
    /deep/ h3,
    /deep/ h4,
    /deep/ h5,
    /deep/ h6 {
      margin-top: 1.5em;
      margin-bottom: 0.5em;
    }

    /deep/ h1 {
      font-size: 28px;
    }
    /deep/ h2 {
      font-size: 24px;
    }
    /deep/ h3 {
      font-size: 20px;
    }
    /deep/ h4 {
      font-size: 18px;
    }
    /deep/ h5 {
      font-size: 16px;
    }
    /deep/ h6 {
      font-size: 14px;
    }

    /deep/ p {
      margin: 0.8em 0;
    }

    /deep/ ol,
    /deep/ ul {
      padding-left: 1.5em;
      margin: 0.8em 0;
    }

    /deep/ blockquote {
      border-left: 4px solid #16cfd0;
      padding-left: 16px;
      margin: 1em 0;
      color: #666;
      background: #f7f7f7;
      padding: 12px 16px;
    }

    /deep/ img {
      max-width: 100%;
      height: auto;
    }

    /deep/ a {
      color: #16cfd0;
      text-decoration: none;
    }

    /deep/ a:hover {
      text-decoration: underline;
    }

    /deep/ strong,
    /deep/ b {
      font-weight: bold;
    }

    /deep/ em,
    /deep/ i {
      font-style: italic;
    }

    /deep/ u {
      text-decoration: underline;
    }

    /deep/ s,
    /deep/ strike {
      text-decoration: line-through;
    }

    /deep/ mark {
      background-color: #ffe58f;
      color: inherit;
      padding: 1px 3px;
    }
  }
}

.date-meta-text {
  i {
    margin-right: 10px;
    color: #989898 !important;
    font-size: 14px;
  }

  color: #989898 !important;
}

.fujian {
  margin-top: 44px;
  span {
    font-size: 20px;
    color: #333;
  }
  div {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    a {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #16cfd0;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/new/info.vue